import { nanoid } from 'nanoid';
import { createContext } from 'react';

export enum SocketMessageType {
  NEW_CHAT_MESSAGE = 'new-chat-message',
  NEW_WORKFLOW_DISCUSSION_MESSAGE = 'new-workflow-discussion-message',
  USER_WORKFLOW_UPDATED = 'user-workflow-updated',
  STATUS_CHANGE = 'status-change',
  USER_INBOX_UPDATED = 'user-inbox-updated',
  FORM_SUMMARY_UPDATED = 'form-summary-updated',
  AI_REQUEST_UPDATED = 'ai-request-updated',
  AI_CASE_SUBMISSION_MESSAGE = 'ai-case-submission-message',
  PACER_FILING_STATUS_UPDATED = 'pacer-filing-status-updated',
  QUESTIONNAIRE_RESPONSES_UPDATED = 'questionnaire-responses-updated',
  MEANS_TEST_AI_REQUEST_STATUS_UPDATED = 'means-test-ai-request-status-updated',
  QUESTIONNAIRE_USER_ACTIVITY_UPDATED = 'questionnaire-user-activity-updated',
  DOCUMENTS_REGENERATION_STATUS = 'documents-regeneration-status',
}

export type SocketMessage = {
  type: SocketMessageType;
  data: unknown;
  sessionId: string | null;
};

export type SocketContextType = {
  addListener: ({
    fn,
    messageType,
    ignoreSameSessionEvents,
  }: {
    fn: (data: unknown) => unknown;
    messageType: SocketMessageType;
    ignoreSameSessionEvents?: boolean;
  }) => string;
  isInitialized: boolean;
  joinChannels: (channelIds: string[]) => Promise<void>;
  removeListener: (id: string) => void;
};

const SocketContext = createContext<SocketContextType>({
  addListener: () => nanoid(),
  isInitialized: false,
  joinChannels: async () => {},
  removeListener: () => {},
});

export default SocketContext;
